import axios from 'axios'

export const SCHEME = 'https://'

const hostname = location.hostname

export function getDomain() {
  return hostname === 'localhost' ? 'unit2.we-connect.jp' : hostname
}

export default {
  get() {
    const domain = getDomain()
    const url = `${SCHEME}${domain}/${domain}/theme.json`

    return axios.get(url)
  }
}
